import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import {
  Filters,
  GridCard,
  Header,
  Pagination,
  Table,
  Tabs,
} from "Components/PollsAndSurveys";
import { TableProps } from "Components/Organizations/Table/types";
import { PollsAndSurveysTable } from "hooks/useTable";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { RootState } from "store";
import { fetchOrganizationsAction } from "store/oranizations";
import { filtersInitialState } from "store/filters/initialState";
import { useParams } from "react-router-dom";
import NoRecordFound from "view/components/NoRecordFound";
import { TailSpin } from "react-loader-spinner";
import { IFetchPolls } from "store/pollsAndSurveys/initialState";
import { fetchPollsAndSurveysAction } from "store/pollsAndSurveys";
import usePermissions from "hooks/usePermissions";
import { pollsAndSurveysResetFiltersAction } from "store/filters";
import { saveFiltersDataToLocalStorage } from "utils/cacheOrRetriveFiltersDate";
import { setPollsAnSurveysFiltersAction } from "store/filters/reducer.actions";
import useCustomBranding from "hooks/useCustomBranding";

export const PollsSurveys = () => {
  const [showInput, setShowInput] = useState(false);
  const { programId } = useParams();
  const inputRef = useRef<HTMLDivElement>(null);
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const { primaryColor } = useCustomBranding();

  useLayoutEffect(() => {
    dispatch(setPollsAnSurveysFiltersAction());
  }, []);

  const { data, stateIs } = useSelector<RootState, IFetchPolls>(
    (state) => state?.pollsAndSurveys
  );

  const { pollsAndSurveysFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );

  const isRowSelected = (rowId: string) => selectedRows.includes(rowId);
  const {
    flexRender,
    columnVisibility,
    columnOrder,
    columnsConfig,
    selectedRows,
    selectAll,
    table,
    setSelectAll,
    setSelectedRows,
    setColumnOrder,
    setColumnVisibility,
    setSorting,
    sorting,
  } = PollsAndSurveysTable(data?.polls);

  useEffect(() => {
    dispatch(fetchPollsAndSurveysAction(programId));
    saveFiltersDataToLocalStorage(pollsAndSurveysFilter);
  }, [pollsAndSurveysFilter]);

  // useEffect(() => {
  //   return () => {
  //     dispatch(pollsAndSurveysResetFiltersAction());
  //   };
  // }, []);
  return (
    <div className="flex flex-col items-start justify-start w-full pt-4 pb-20">
      <div className="flex flex-col items-start justify-start flex-grow-0 flex-shrink-0 w-full gap-3">
        <Header />
        <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 w-full gap-4">
          <div className="flex flex-col items-start justify-start flex-grow-0 flex-shrink-0 w-full">
            <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-4">
              <div className="flex justify-start  flex-wrap items-center self-stretch flex-grow-0 flex-shrink-0 min-h-[60px]">
                <Tabs />
              </div>
            </div>
          </div>
          <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0">
            <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-2">
              <Filters
                columnOrder={columnOrder}
                setColumnOrder={setColumnOrder}
                columns={columnsConfig}
                columnVisibility={columnVisibility}
                setColumnVisibility={setColumnVisibility}
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 w-full dark:bg-secondaryLight bg-bgWhite">
          {stateIs == "Idle" && data?.polls?.length === 0 ? (
            <NoRecordFound />
          ) : stateIs === "Pending" ? (
            <div className="loader min-h-[45vh] justify-center items-center flex w-full">
              <TailSpin
                height="50"
                width="50"
                color={primaryColor}
                ariaLabel="tail-spin-loading"
                radius="2"
                wrapperStyle={{}}
                wrapperClass="tailspin-loader"
                visible={true}
              />
            </div>
          ) : (
            <Table
              flexRender={flexRender}
              table={table}
              columnOrder={columnOrder}
              columns={columnsConfig}
              columnVisibility={columnVisibility}
              isRowSelected={isRowSelected}
              selectAll={selectAll}
              setSelectAll={setSelectAll}
              setSelectedRows={setSelectedRows}
              setSorting={setSorting}
              sorting={sorting}
            />
          )}
          <Pagination />
        </div>
      </div>
    </div>
  );
};

export default PollsSurveys;
